<template>
  <div class="flex flex-wrap items-center gap-1">
    <div
      v-for="{ name, style } in swatches"
      :key="name"
      class="size-4 @[280px]:size-6 rounded-full"
      :style
      :title="name"
    />
    <div v-if="swatchesLeft" class="text-muted text-xs font-semibold leading-none">
      {{ `+${swatchesLeft}` }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SwatchColor } from '~/types/swatch'
import { useSwatch } from '~/composables/useSwatch'

const props = defineProps({
  swatchColors: {
    type: Array as () => SwatchColor[],
    required: false,
    default: () => []
  },
  max: {
    type: Number,
    default: 5
  }
})

const { parseSwatchColor } = useSwatch()
const visibleQty = computed(() => props.swatchColors.length > props.max ? props.max - 1 : props.max)
const swatches = computed(() => props.swatchColors.slice(0, visibleQty.value).map(color => parseSwatchColor(color)))
const swatchesLeft = computed(() => Math.max(props.swatchColors.length - visibleQty.value, 0))
</script>
